import { BanknotesIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../../feature.types";
import { buildCrudPermissions, permissionId } from "../../../shared/featureFactories";

function buildViewOnlyPermissions(action: string) {
  return { view: action, create: action, edit: action, delete: action };
}

export const AddHeaderFeature: FeatureMetadata = {
  id: "accounts-add-header",
  moduleName: "feesFinance",
  navigation: {
    label: "Add Header",
    path: "/accounts/add-header",
    icon: BanknotesIcon,
    order: 1,
    parentId: "accounts",
  },
  route: {
    path: "/accounts/add-header",
    element: lazy(() => import("./pages/AccountsPage")),
  },
  permissions: buildCrudPermissions(
    "FeeFinance",
    "Accounts",
    buildViewOnlyPermissions(permissionId("FeeFinance", "Accounts", "addHeader")),
  ),
  readiness: "live",
};
